import React, { useState } from 'react';
import Logo from './images/logo-bookmark.svg';
import Logo2 from './images/logo-bookmark2.svg';
import Dropdown from './images/icon-hamburger.svg';
import './App.css';

const MobileHeader = () => {
  const [navHeight, setNavHeight] = useState(0);

  const openNav = () => {
    setNavHeight('100%');
  };

  const closeNav = () => {
    setNavHeight(0);
  };

  return (
    <header className='header' style={{ justifyContent: 'space-between' }}>
      <div className='logodiv' style={{ marginLeft: '30px' }}>
        <img src={Logo} alt="Logo" />
      </div>
      <nav className='navbar' style={{ marginRight: '30px' }}>
        
        <img src={Dropdown} alt="Dropdown" onClick={openNav} />
      </nav>

      {/* Navigation BAR on Mobile */}
      <div id="myNav" className="overlay" style={{ height: navHeight }}>
      
        
        <div className="overlay-content">
        <div className='logodiv'>
        <img src={Logo2} alt="Logo" width={200} />
        <a href="javascript:void(0)" className="closebtn" onClick={closeNav}>&times;</a>
      </div>
          <a href="#">FEATURES</a>
          <a href="#">PRICING</a>
          <a href="#">CONTACT</a>
          <button className='btn'>
            LOGIN
          </button>
          
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
